<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Nuevo Convoy </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
        <div class="col-md-12">
            <div class="form-group col-md-12">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            </div>
            <br>
            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                                [id]    ="DAT_AG_GRID.id" 
                                [class] ="DAT_AG_GRID.class" 
                                [ngStyle]="DAT_AG_GRID.style" 
                                [rowData]="rowData" 
                                [rowHeight]="DAT_AG_GRID.rowHeight"
                                [columnDefs]="columnDefs"
                                [pagination]="DAT_AG_GRID.pagination" 
                                [paginationPageSize]="DAT_AG_GRID.pagina"
                                [allowContextMenuWithControlKey]="true"
                                [frameworkComponents]="frameworkComponents" >
            </ag-grid-angular>
        </div>
        <!-- GRILLA [rowSelection]="rowSelectionPedidos"-->
    </ng-template>
  </div>
  
    <!-- MODAL -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'" 
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>
  
    <ng-template #abrirModal>
        <div class="container-fluid">
            <h6>Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>
            <form [formGroup]="formulario" mat-dialog-content class="col-md-12" >
                <div class="row">
                    <div class="col-2" *ngIf="!isCreate">
                        <!---<app-lfsa-input formControlName="idConvoy" [label]="'ID Convoy '" [id]="'idConvoy'"
                            [isReadOnly]="false" [control]="formulario.get('idConvoy')" [type]="'number'" class="form-control-sm" >
                        </app-lfsa-input>-->
                        <label class="form-label mb-1"><b>ID Convoy</b></label>
                        <input id="idConvoy" type="number" class="form-control form-control-sm" formControlName="idConvoy" readonly />
                    </div>
                    <div class="col"> <!--(change)="getColaborador()" -->
                        <app-lfsa-combo-box [id]="'grupo'"  [label]="'* Código/Grupo Convoy'" formControlName="grupo" [control]="formulario.get('grupo')" 
                                            [comboBox]="listConvoysParametro" [opcion]="'nombreParametro'" [idOpcion]="'nombreParametro'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <!--<div class="col-3">
                        <label class="form-label mb-1"><b>Fecha llegada</b></label>
                        <input id="fechaLlegada" type="date" class="form-control form-control-sm" formControlName="fechaLlegada" readonly />
                    </div> -->
                    <div class="col-3">
                        <label for="fechaSalida" style="font-size: .875rem;">Fecha y hora de Salida</label>
                        <input autocomplete="off" class="form-control" formControlName="fechaSalida" id="fechaSalida" name="fechaSalida" 
                                type="datetime-local" max="2030-12-31T00:00" />
                        <small *ngIf="this.formulario.get('fechaSalida')?.hasError('required') && 
                                this.formulario.get('fechaSalida').touched" class="text-danger">*Campo obligatorio</small>
                        <small *ngIf="formulario.hasError('dateRangeInvalid') && formulario.get('fechaSalida')?.touched" class="text-danger">
                            *La fecha de salida no puede ser menor a la fecha de llegada</small>
                    </div>
                    <div class="col-3">
                        <app-lfsa-input formControlName="creadoPor" [label]="'Creado por'" [id]="'creadoPor'" [isReadOnly]="true" 
                        [control]="formulario.get('creadoPor')" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col-12">
                        <app-lfsa-input formControlName="observacion" [label]="'* Detalles u otras observaciones del Convoy'" [id]="'observacion'" 
                            [control]="formulario.get('observacion')" [placeholder]="'Observaciones'"
                            class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>                    
                    </div>
                </div>  
            </form>
            <h5>Asignar Viajes </h5>
            <form [formGroup]="formDetalle" mat-dialog-content>
                <input type="hidden" formControlName="viajeId" />
                <input type="hidden" formControlName="viajeDetalle" />

                <div class="row align-items-end">
                    <div class="col-7">
                        <label class="form-label"><b>Chofer</b></label>
                        <ng-select [items]="listChoferesDropdown"
                                   bindLabel="display"
                                   bindValue="idViaje"
                                   placeholder="Seleccione chofer"
                                   [(ngModel)]="selectedChoferViajeId"
                                   [ngModelOptions]="{standalone: true}"
                                   (change)="onChoferChange($event)">
                        </ng-select>
                    </div>
                    <div class="col-3">
                        <div class="form-check">
                            <input class="form-check-input" formControlName="esLider" id="esLider" type="checkbox">
                            <label class="form-check-label" for="esLider">Viaje Lider</label>
                        </div>
                    </div>
                    <div class="col-1">
                        <button type="button" (click)="addDetalle()" class="btn btn-block btn-primary"> <i aria-hidden="true" class="fa fa-check"></i> </button>
                    </div>   
                </div>            
            </form>

            <!--TABLA CARGA -->
            <div class="row my-4 border rounded">
                <div class="mb-3 bg-body-secondary text-center" *ngIf="listAsignaciones.length == 0"> Sin detalles </div>
                <div class="col-12" *ngIf="listAsignaciones.length > 0">
                    <div class="table-responsive">
                        <table class="table table-sm table-striped table-hover align-middle mb-0" style="font-size: 0.85rem;">
                            <thead class="table-light">
                                <tr>
                                    <th class="text-nowrap">Viaje</th>
                                    <th>Chofer</th>
                                    <th>Proveedor</th>
                                    <th class="text-nowrap">Placa</th>
                                    <th class="text-nowrap">Furgón</th>
                                    <th class="text-nowrap">Rol</th>
                                    <th class="text-end text-nowrap">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of listAsignaciones; index as i">
                                    <td class="text-nowrap fw-semibold">#{{ item.viajeId }}</td>
                                    <td>{{ item.choferNombre || '-' }}</td>
                                    <td>{{ item.nombreProveedor || '-' }}</td>
                                    <td class="text-nowrap">{{ item.placa || '-' }}</td>
                                    <td class="text-nowrap">{{ item.furgon || '-' }}</td>
                                    <td class="text-nowrap">
                                        <span class="badge bg-success" *ngIf="item.esLider; else noLider">Líder</span>
                                        <ng-template #noLider><span class="badge bg-secondary">Normal</span></ng-template>
                                    </td>
                                    <td class="text-end">
                                        <button (click)="deleteDetalle(i, item)" class={{DAT_BTNCSS.danger}}> X </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
            <div class="d-flex justify-content-end mb-2" *ngIf="!isCreate">
                <button type="button" (click)="enviarMails()" class={{DAT_BTNCSS.infoOutline}} [disabled]="loading || !formulario.get('idConvoy')?.value">
                    Enviar mails
                </button>
            </div>

            <app-lfsa-botones-formulario 
                [formularioValido]="formulario.invalid" 
                (devolverAccion)="acciones( $event )" 
                [textBoton]="'Guardar'">
            </app-lfsa-botones-formulario>
        </div>
    </ng-template> 
    <!-- END MODAL --> 
